import React, { useEffect, useRef, useState } from 'react';

import './Article.scss';

import Poll from '../Poll/Poll.jsx';
import { link } from '../../helpers/link';
import IconsBar from '../IconsBar/IconsBar.jsx';
import CommentList from '../CommentList/CommentList.jsx';
import ExpertBanner from '../ExpertBanner/ExpertBanner.jsx';
import { srcSet, useDimensions } from '../../helpers/image';
import { getAdvertisementData } from '../../helpers/metadata';
import parseContentHTML from '../../helpers/parseContentHTML';
import BabyweeksBanner from '../BabyweeksBanner/BabyweeksBanner.jsx';
import PregnancyCalendar from '../PregnancyCalendar/PregnancyCalendar.jsx';
import SurveyQuickForm from '../redesign/SurveyQuickForm/SurveyQuickForm.jsx';

import ArticleAdvertisement from '../ArticleAdvertisement/ArticleAdvertisement.jsx';

import { convert } from '../../helpers/date';

export default function Article(props) {
  const {
    uri,
    ads,
    tags,
    poll,
    user,
    isTag,
    intro,
    title,
    locale,
    config,
    author,
    expert,
    postedAt,
    metadata,
    loginUrl,
    useQuery,
    comments,
    formData,
    imageUrl,
    nextLink,
    updatedAt,
    shareUrls,
    bookmarks,
    addComment,
    isCategory,
    contentHTML,
    editComment,
    addBookmark,
    getListQuery,
    addFormAnswer,
    isPreviewMode,
    deleteComment,
    commentAuthor,
    removeBookmark,
    showLoginPopup,
    setUserListItem,
    getUserListItem,
    addSurveyAnswer,
    commentsEnabled,
    subscribeChannel,
    submitFormAnswer,
    unsubscribeChannel,
    productCategoryQuery
  } = props;
  const [adName, adUrl] = getAdvertisementData(metadata) || [];

  const updatedDate = updatedAt && convert(updatedAt, locale);
  const postedDate = postedAt && convert(postedAt.replace(/-/g, '/'), locale);

  const week = uri.match(/^week-\d+$/);

  const weekNumber = week && week[0].split('-').pop();

  const ref = useRef();

  const dimensions = useDimensions(ref);

  const contentBlocks = parseContentHTML(contentHTML);

  useEffect(() => {
    if (window && window.iFrameResize)
      window.iFrameResize({ log: false }, '#formframe');
  }, []);

  return (
    <article id="article">
      {week ? (
        <React.Fragment>
          <PregnancyCalendar hideWeekList={true} />

          <BabyweeksBanner week={+weekNumber} nextLink={nextLink} />
        </React.Fragment>
      ) : (
        <div id="article_image" ref={ref}>
          {dimensions && (
            <img alt="article-image" srcSet={srcSet(imageUrl, dimensions)} />
          )}
        </div>
      )}

      <div id="article_content">
        <p id="article_title">{title}</p>

        <div id="article_contributor">
          <React.Fragment>
            {link(<p>{author.displayName}</p>, author.link)},{' '}
          </React.Fragment>

          {postedDate && <span>{postedDate}</span>}

          {updatedDate && (
            <span className="article_updated_date">
              Laatste update op: {updatedDate}
            </span>
          )}

          {adName && (
            <span id="article_channel_advertisement">
              <br />
              In samenwerking met:{' '}
              <a href={adUrl} target="_blank" rel="noopener noreferrer">
                {adName}
              </a>
            </span>
          )}
        </div>

        <IconsBar
          user={user}
          config={config}
          contentUri={uri}
          bookmarks={bookmarks}
          shareUrls={shareUrls}
          addBookmark={addBookmark}
          showLoginPopup={showLoginPopup}
          removeBookmark={removeBookmark}
        />

        <div className="article_text">
          <p id="article_text_intro">{intro}</p>

          {contentBlocks.map((block, idx) => {
            if (block.html)
              return (
                <div
                  className="article_parsed_html"
                  key={idx}
                  dangerouslySetInnerHTML={{ __html: block.html }}
                />
              );

            if (!block.component) return null;

            const Component = block.component;

            return (
              <Component
                key={idx}
                {...props}
                {...block.args}
                loginUrl={loginUrl}
                useQuery={useQuery}
                username={user.username}
                getListQuery={getListQuery}
                imageUrl={block.args.imageUrl}
                getUserListItem={getUserListItem}
                setUserListItem={setUserListItem}
                productCategoryQuery={productCategoryQuery}
              />
            );
          })}
        </div>
      </div>

      {!!tags.length && (
        <div id="article_tags">
          <p>Meer over dit onderwerp:</p>

          <ul>
            {tags.map((tag) => (
              <li key={tag.id}>
                {link(<span>{tag.title}</span>, `/${tag.uri}`, nextLink)}
              </li>
            ))}
          </ul>
        </div>
      )}

      {ads && <ArticleAdvertisement ads={ads} />}

      {expert.displayName && (
        <ExpertBanner
          {...expert}
          user={user}
          fullSized={true}
          showLoginPopup={showLoginPopup}
          subscribeChannel={subscribeChannel}
          unsubscribeChannel={unsubscribeChannel}
        />
      )}

      {user.username && (
        <Poll
          item={poll}
          username={user.username}
          addSurveyAnswer={addSurveyAnswer}
        />
      )}

      {!isPreviewMode && commentsEnabled && !isTag && !isCategory && (
        <CommentList
          uri={uri}
          user={user}
          comments={comments}
          addComment={addComment}
          editComment={editComment}
          deleteComment={deleteComment}
          commentAuthor={commentAuthor}
          showLoginPopup={showLoginPopup}
        />
      )}

      {contentHTML && (
        <div id="article_survey">
          <SurveyQuickForm
            item={formData.form}
            addFormAnswer={addFormAnswer}
            metadata={{ contentTitle: title }}
            submitFormAnswer={submitFormAnswer}
            completeButtonLabel="Verzenden"
          />
        </div>
      )}
    </article>
  );
}
